<div>
  <div class="row">
    <div class="col-md-12 col-lg-8 mb-1 align-items-stretch ">  
      <h6 class="mb-2 text-muted"><b>Welcome user: <b>{{userProfile.userName}}</b>, owner <b>{{userProfile.ownerName}}</b></b></h6>
    </div>    
  </div> <!--row ends--> 
  <div class="row">  
    <div class="col-md-12 col-lg-12 mb-4 align-items-stretch "> 
      <span>All the data shown are based on current selected academic session. If you need to change session then can change from header link</span>
    </div>
  </div>
  <div class="row">  
    <div class="col-md-12 col-lg-12 mb-4 align-items-stretch "> 
      <span>Below are the guidelines & checklist to setup master data for the very first time.</span>
    </div>
  </div>
</div>